import moment from '../../../helpers/moment'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'

import useInterval from '../../../helpers/interval-hook'

 
const useStyles = makeStyles(timerStyles)

export default function Timer ({context}) {

  const classes = useStyles()
  const {assessment, translate} = context

  const [count, setCount] = React.useState(0)

  useInterval(() => {
    setCount(count - 1)
  }, count  > 0 ? 1000 : null)

  const duration = moment.duration(assessment.duration, 'seconds').humanize();

  React.useEffect(()=>{
    if (assessment.started) {
      const deadline = moment(assessment.started).add(assessment.duration, 'seconds')
      const remaining = moment.duration(deadline.diff(moment()))
      const countdown = Math.floor(remaining.asSeconds())
      setCount(countdown)
    }
  }, [assessment.started])

  return (
    <Paper className={classes.root}>
      <Box className={classes.countdown}>
        {formatCountDown(count)}
      </Box>
      <Box className={classes.duration}>
        <Box className={classes.durationLabel}>{translate('assessment-duration')}:</Box>
        <Box>{duration}</Box>
      </Box>
    </Paper>
  )  

}

function formatCountDown (time) {
  const hours = Math.floor(time / 3600).toString().padStart(2,0)
  const minutes = Math.floor((time % 3600) / 60).toString().padStart(2,0)
  const seconds = Math.floor(time % 60).toString().padStart(2,0)
  return `${hours}:${minutes}:${seconds}`
}



export function timerStyles (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 18,
      padding: 25,
      color: '#505163',
    },
    countdown: {
      display: 'flex',
      justifyContent: 'center',
      fontSize: '18pt',
      fontWeight: 'bold',
      color: '#1e4c97'
    },
    duration: {
      marginTop: 10,
      fontSize: '9pt',
      display: 'flex'
    },
    "durationLabel": {
      marginRight: 3
    }
  }
}
